export const SKU_SUBSTITUTION_TYPE_ORIGINAL = "original";
export const SKU_SUBSTITUTION_TYPE_SUBSTITUTE = "substitute";

export const SKU_TYPE_NEW = "new";
export const SKU_TYPE_SECOND_HAND = "second_hand";
